'use strict';
$('.full-screen-video-banner').on("click", function() {
    var $videoHeroVideo = $(this).closest('.full-screen-video-banner').find('.full-screen-video-banner-video-wrapper');

    var $iframe = $(this).closest('.full-screen-video-banner').find('.full-screen-video-banner-video-wrapper iframe');
    if ($iframe.length > 0) {
        var $player = new Vimeo.Player($iframe);
        $player.on('ended',function(){
            videoEnded($videoHeroVideo);
          });
    }

    $videoHeroVideo.addClass("video-show");
    $player.play();
});

function videoEnded(videoHeroVideo) {
    setTimeout(function() {
        videoHeroVideo.removeClass("video-show");
    }, 500);
};

